import restService from './rest.service'

async function solicitarAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/solicitar', credentials);
    return data;
}

async function recuperarAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/recuperar', credentials);
    return data;
}

async function verificarAsync(token) {
    const { data } = await restService.postAsync('recuperacao/verificar', { token });
    return data;
}

async function medicoRegistroAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/medicoRegistro', credentials);
    return data;
}

async function solicitarTokenAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/solicitarToken', credentials);
    return data;
}

async function validarTokenAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/validarToken', credentials);
    return data;
}

async function validarTokenPacienteAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/validarTokenPaciente', credentials);
    return data;
}

async function alterarSenhaTokenAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/alterarSenhaToken', credentials);
    return data;
}

async function pacienteRegistroAsync(credentials) {
    const { data } = await restService.postAsync('recuperacao/loginPacienteRegistro', credentials);
    return data;
}

export default { solicitarAsync, recuperarAsync, verificarAsync, medicoRegistroAsync, solicitarTokenAsync, validarTokenAsync, alterarSenhaTokenAsync, validarTokenPacienteAsync, pacienteRegistroAsync }
